module.exports = __webpack_public_path__ + "img/list.3b229179.svg";